import { memo } from 'react';
import { LockedLabelProps } from './LockedLabel.types';
import { Box, Icon, Text } from '@betty/moonlight';

function LockedLabel({ label }: LockedLabelProps) {
  return (
    <Box
      flexDirection="row"
      alignItems="center"
      gap="space-100"
      alignSelf="center"
      paddingTop="space-050"
    >
      <Icon name="lockFilled" color="iconSecondary" />
      <Text variant="caption" color="darkSurfacePrimary">
        {label}
      </Text>
    </Box>
  );
}

export default memo(LockedLabel);
